(() => {
  const pushEvent = (name, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  };

  const initSelector = (root) => {
    if (!root || root.dataset.sfInitialized === 'true') return;
    root.dataset.sfInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));

    const activate = (tab, focus = false) => {
      const targetId = tab.getAttribute('aria-controls');
      tabs.forEach((item) => {
        const selected = item === tab;
        item.setAttribute('aria-selected', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => {
        panel.hidden = panel.id !== targetId;
      });
      if (focus) tab.focus();

      pushEvent('sf_santo_selecao_produtos', {
        grupo: tab.dataset.groupLabel || tab.textContent.trim(),
        colecao: root.dataset.collectionHandle || ''
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        activate(tabs[nextIndex], true);
      });
    });
  };

  const initGallery = (root) => {
    if (!root || root.dataset.sfGalleryReady === 'true') return;
    root.dataset.sfGalleryReady = 'true';
    const track = root.querySelector('.sf-santo-gallery__track--carousel');
    if (!track) return;

    const autoplay = root.dataset.autoplay === 'true';
    const speed = parseInt(root.dataset.speed || '45', 10);
    if (!autoplay) return;

    track.style.animation = `sfSantoGalleryScroll ${speed}s linear infinite`;
  };

  const injectKeyframes = () => {
    if (document.getElementById('sf-santo-keyframes')) return;
    const style = document.createElement('style');
    style.id = 'sf-santo-keyframes';
    style.textContent = `@keyframes sfSantoGalleryScroll { from { transform: translateX(0); } to { transform: translateX(calc(-50% - 8px)); } }`;
    document.head.appendChild(style);
  };

  const init = (scope = document) => {
    injectKeyframes();
    scope.querySelectorAll('[data-sf-selector]').forEach(initSelector);
    scope.querySelectorAll('[data-sf-gallery]').forEach(initGallery);

    scope.querySelectorAll('[data-sf-scroll]').forEach((link) => {
      if (link.dataset.sfScrollInitialized === 'true') return;
      link.dataset.sfScrollInitialized = 'true';
      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || !selector.startsWith('#')) return;
        const target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
